import { createSendLogEntry, type SendLogOrderType, type SendLogType } from "api/postTypeApiCalls";
import { safeConsole } from "utils/envUtils";
import { getAuthCookie } from "../../utils/authCookies";

export const ACTIVE_TYPE_TENANT = getAuthCookie("userId") || "default";

export function getSendLogOrderType(order: any): SendLogOrderType {
  const raw = String(order?.order_type || order?.type || "").toLowerCase();
  if (raw.includes("installation")) return "installation_orders";
  if (raw.includes("removal")) return "removal_orders";
  return "orders";
}

export function getSendLogOrderId(order: any): string {
  return String(order?.id || order?._id || order?.order_id || "").trim();
}

export async function logSendEvent(order: any, token: string, type: SendLogType): Promise<void> {
  const orderId = getSendLogOrderId(order);
  if (!orderId || !token) return;
  try {
    await createSendLogEntry({
      orderType: getSendLogOrderType(order),
      orderId,
      type,
      token,
    });
  } catch (e) {
    safeConsole.warn("[SalesOrderDetails] send-log failed:", e);
  }
}
